import React from 'react'
import PropTypes from 'prop-types'
import { ArticleMeta } from 'components/Meta'
import LandingView from 'components/Landing'

const LandingTemplate = ({ data, pathContext }) => {
  const { articleBody } = pathContext
  const { post, file } = data

  const datePublished = new Date(post.frontmatter.date).toISOString()
  const dateModified = file.modifiedTime

  return (
    <div>
      <ArticleMeta
        title={post.frontmatter.title}
        shortDescription={post.frontmatter.shortDescription}
        thumbnail={post.frontmatter.thumbnail}
        genre="health"
        tags={post.frontmatter.tags}
        wordCount={post.wordCount.words}
        datePublished={datePublished}
        dateModified={dateModified}
        articleBody={articleBody}
        excerpt={post.excerpt}
        path={post.fields.slug}
      />
      <LandingView
        html={post.html}
        slug={post.fields.slug}
        {...post.frontmatter}
      />
    </div>
  )
}

LandingTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  pathContext: PropTypes.shape({
    articleBody: PropTypes.string.isRequired,
  }).isRequired,
}

// eslint-disable-next-line
export const query = graphql`
  query LandingPageQuery($path: String!, $fileAbsolutePath: String!) {
    post: markdownRemark(fields: { slug: { eq: $path } }) {
      html
      excerpt(pruneLength: 300)
      timeToRead
      wordCount {
        words
      }
      fields {
        slug
      }
      frontmatter {
        title
        landingUrl
        date
        shortDescription
        tags
        landingType
        # sections
        # bonus1
        # bonus2
        # bonus3
        # ending
      }
    }
    file(absolutePath: { eq: $fileAbsolutePath }) {
      modifiedTime
    }
  }
`

export default LandingTemplate



// WEBPACK FOOTER //
// ./src/templates/landing.js